import { createAction } from '@reduxjs/toolkit';
import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

export const getBanks = asyncActionCreator(constants.GET_BANKS);
export const getDatabase = asyncActionCreator(constants.GET_DATABASE);
export const getRowsColumnByTable = asyncActionCreator(constants.GET_ROWS_COLUMNS_BY_TABLES);
export const getColumns = asyncActionCreator(constants.GET_COLUMNS);
export const getTables = asyncActionCreator(constants.GET_TABLES);
export const getCharts = asyncActionCreator(constants.GET_CHARTS);
export const openOperationsMenu = createAction(constants.OPEN_OPERATIONS_MENU);
export const openPrintDialog = createAction(constants.OPEN_PRINT_DIALOG);
export const openDatapoints = createAction(constants.OPEN_DATAPOINTS);
export const setTreeData = createAction(constants.SET_TREE_DATA);
export const setSelectedBanks = createAction(constants.SET_SELECTED_BANKS);
export const unsetSelectedBanks = createAction(constants.UNSET_SELECTED_BANKS);
export const updateDataBase = createAction(constants.UPDATE_DATABASE);
export const updatePeriod = createAction(constants.UPDATE_PERIOD);
export const updateKeys = createAction(constants.UPDATE_KEYS);
export const updateDataPoints = createAction(constants.UPDATE_DATAPOINTS);
export const unsetDataPoints = createAction(constants.UNSET_DATAPOINTS);
export const clearSelectedData = createAction(constants.CLEAR_SELECTED_DATA);

export default getBanks;
